import { render, staticRenderFns } from "./Reportcard.vue?vue&type=template&id=763690fe"
import script from "./Reportcard.vue?vue&type=script&lang=js"
export * from "./Reportcard.vue?vue&type=script&lang=js"
import style0 from "./Reportcard.vue?vue&type=style&index=0&id=763690fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports